/**
 * Scroll parent to get child into view.
 *
 * @param {HTMLElement | null} container: container element that has overflow: auto/scroll
 * @param {HTMLElement | null} child: child element
 */
export const scrollContainerToChild = (
  container: HTMLElement | null,
  child: HTMLElement | null
) => {
  if (!container || !child) {
    return;
  }
  // Fill child's immediate parent with enough empty space that allow child to be scrolled at top
  if (child.parentElement) {
    const scrollHeight =
      child.parentElement.scrollHeight - parseInt(child.parentElement.style.paddingBottom || '0');
    const padding =
      scrollHeight <= child.parentElement.offsetHeight
        ? Math.max(child.offsetTop + container.offsetHeight - scrollHeight, 0)
        : Math.max(child.offsetTop + child.parentElement.offsetHeight - scrollHeight, 0);
    child.parentElement.style.paddingBottom = `${padding}px`;
  }

  container.scrollTo({ top: child.offsetTop, behavior: 'smooth' });
};
